// extracted by mini-css-extract-plugin
module.exports = {"root":"heroCard_root__X_gSA","cardContainer":"heroCard_cardContainer__3IWwz","cardImg":"heroCard_cardImg__2Rc1k","cardDesc":"heroCard_cardDesc__Y4gzy","btn":"heroCard_btn__2eNl_"};